import { Divider } from 'antd'
import { Variants, motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import AnimatedLink from './AnimatedLink'
import Curve from './Navbar-Curve'

type Props = {
    handleClose: () => void
}

const slide: Variants = {
    initial: {
        x: 'calc(100% + 100px)'
    },
    enter: (i) => ({
        x: '0px',
        transition: {
            duration: 0.8,
            ease: [0.65, 0, 0.35, 1],
            delay: 0.1 * i
        }
    }),
    exit: (i) => ({
        x: 'calc(100% + 100px)',
        transition: {
            duration: 0.8,
            ease: [0.65, 0, 0.35, 1],
            delay: 0.1 * i
        }
    })
}

export default function Navbar({ handleClose }: Props) {
    const location = useLocation()
    const { t } = useTranslation('Navbar')

    const NavItems: {
        label: string
        path: string
    }[] = [
        {
            label: t('Home'),
            path: '/'
        },
        {
            label: t('Contestants'),
            path: '/contestants'
        }
    ]

    return (
        <motion.nav
            variants={slide}
            initial="initial"
            animate="enter"
            exit="exit"
            className="fixed right-0 top-0 z-40 flex h-screen w-[80vw] flex-col bg-[#18181b] fill-[#18181b] px-12 pb-12 pt-32 text-neutral-100 lg:w-[30vw]"
        >
            <Curve onClick={handleClose} className="right-[79vw] cursor-pointer fill-inherit lg:right-[29vw]" />
            <header>
                <h1 className="mb-3 text-[16px] font-light uppercase leading-3 tracking-wider">{t('Navigation')}</h1>
                <Divider className="m-0 h-[1px] rounded-full bg-neutral-100 p-0 leading-[0]" />
            </header>
            <div className="mt-6 flex flex-grow flex-col gap-3">
                {NavItems.map((item, index) => (
                    <AnimatedLink
                        index={index}
                        label={item.label}
                        path={item.path}
                        onClick={handleClose}
                        isActive={location.pathname === item.path}
                        className="text-neutral-100"
                    />
                ))}
            </div>
            <footer className="flex justify-between gap-3">
                <Link to="https://www.facebook.com/skillcetera" className="text-sm font-light text-neutral-100">
                    Facebook
                </Link>
                <Link to="https://www.instagram.com/skillcetera/" className="text-sm font-light text-neutral-100">
                    Instagram
                </Link>
                <Link to="https://www.tiktok.com/discover/skillcetera" className="text-sm font-light text-neutral-100">
                    TikTok
                </Link>
            </footer>
        </motion.nav>
    )
}
